// Shared rule for map shortcuts (undo, copy, paste…): text that is being edited keeps its own keys.

const isTextField = (target) =>
    ['INPUT', 'TEXTAREA', 'SELECT'].includes(target?.tagName) || Boolean(target?.isContentEditable);

// Clicking a node focuses its label, so a label owns the keys only once it was typed in (textBox marks that).
export const isEditingText = (target) =>
    isTextField(target) && !(target.dataset?.mapLabel === 'true' && target.dataset.edited !== 'true');

// Ctrl on Windows/Linux, Cmd on macOS.
export const hasCommandKey = (event) => event.ctrlKey || event.metaKey;
